import { FormattedMessage, useIntl } from "react-intl";
import ChevronIcon from "svg-icons/chevron-icon.js";
import {
  formOfDataRequested,
  purposeOfRequestingDataList,
} from "constants/Defaults.js";
import DataRequestItemForm from "./DataRequestItemForm";
import DataRequestSelectField from "./DataRequestSelectField";

function DataRequestForm({
  dir,
  currentLocale,
  userInfo,
  register,
  handleSubmit,
  errors,
  onSubmit,
}) {
  const intl = useIntl();

  return (
    <div className="col-12 col-lg-8">
      <div className="m__title">
        <h3>
          <FormattedMessage id="datarequest" />
        </h3>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DataRequestItemForm
          label={intl.formatMessage({ id: "firstName" })}
          isOptional={true}
        >
          <input
            type="text"
            disabled
            value={userInfo.firstName}
            className="form-control"
          />
        </DataRequestItemForm>

        <DataRequestItemForm
          label={intl.formatMessage({ id: "lastName" })}
          isOptional={true}
        >
          <input
            type="text"
            disabled
            value={userInfo.lastName}
            className="form-control"
          />
        </DataRequestItemForm>

        <div className="form-label row">
          <div className="col-lg-4">
            <label>
              <FormattedMessage id="employer" />
            </label>
          </div>
          <div className="col-lg-8">
            <div className="form-label-container">
              <input
                type="text"
                {...register("employeer")}
                className={`form-control ${
                  errors.employeer ? "is-invalid" : ""
                }`}
              />
              <span>*</span>
            </div>
          </div>
        </div>

        <DataRequestItemForm
          label={intl.formatMessage({ id: "email" })}
          isOptional={true}
        >
          <input
            type="text"
            disabled
            value={userInfo.email}
            className="form-control"
          />
        </DataRequestItemForm>

        <DataRequestItemForm
          label={intl.formatMessage({ id: "phoneNumber" })}
          isOptional={true}
        >
          <input
            type="text"
            disabled
            value={userInfo.phoneNumber}
            className="form-control"
          />
        </DataRequestItemForm>

        <div className="form-label row">
          <div className="col-lg-4">
            <label>
              <FormattedMessage id="required-info" />
            </label>
          </div>
          <div className="col-lg-8">
            <div className="form-label-container">
              <textarea
                name=""
                id=""
                cols="30"
                rows="10"
                {...register("requiredInformation")}
                className={`form-control ${
                  errors.requiredInformation ? "is-invalid" : ""
                }`}
              />
              <span>*</span>
            </div>
          </div>
        </div>

        <DataRequestSelectField
          label={<FormattedMessage id="data-requested" />}
          dir={dir}
          currentLocale={currentLocale}
          registerProps={register("formOfDataRequested")}
          options={formOfDataRequested}
        />

        <DataRequestSelectField
          label={<FormattedMessage id="purpose" />}
          dir={dir}
          currentLocale={currentLocale}
          registerProps={register("purposeOfRequestingData")}
          options={purposeOfRequestingDataList}
        />

        <div className="row-r mt-4">
          <button className="main-btn" type="submit">
            <span>
              <FormattedMessage id="send" />
            </span>
            <ChevronIcon width={12} height={12} color="#FFFFFF" />
          </button>
        </div>
      </form>
    </div>
  );
}

export default DataRequestForm;
